import { ViewModel, View, ObservableArray } from "binder"
import { StopReasonManipulationView } from "./stopReasonManipulation-view"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { ServerConnection } from "src/server/serverConnection";
import { IStopReason } from "./IStopReason";
import { StopReasonEditorViewModel, StopReasonInserter, StopReasonUpdater } from "./StopReasonEditor/stopReasonEditor-viewModel";
import { StopGroupSelectorViewModel } from "./stopGroupSelector-viewModel";

export class StopReasonManipulationViewModel extends WindowViewModel {
    public getTitle(): string {
        return 'تعریف علت توقف';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.isLoading = false;
        this.stopReasons = ObservableArray.create<StopReason>();
        this.dataLoader = new ServerSideDataLoader(filteringInformation => this.refreshPaged(filteringInformation), 30);

        this.refresh()
    }
    GetDefaultView(): View<ViewModel> {
        return new StopReasonManipulationView();
    }
    public getTypeId(): string {
        return "VM-77AAFAE8-AF67-4475-9D7D-A2CB632B267C"
    }
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set stopReasons(v: ObservableArray<StopReason>) { this._stopReasons = v; } public get stopReasons(): ObservableArray<StopReason> { return this._stopReasons; } private _stopReasons: ObservableArray<StopReason>;
    public set dataLoader(v: ServerSideDataLoader) { this._dataLoader = v; } public get dataLoader(): ServerSideDataLoader { return this._dataLoader; } private _dataLoader: ServerSideDataLoader;

    async refresh() {
        await this.dataLoader.refresh();
    }

    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/StopReasonServices/ListAllStopReasons', {
                FilteringInformation: filteringInformation
            });
            this.stopReasons.update(...result.StopReasons.map((x, i) => {
                let s = new StopReason(this);
                s.index = ((result.PaginationInfo.CurrentPage - 1) * result.PaginationInfo.PageSize) + i + 1;
                s.id = x.Id;
                s.name = x.Name;
                s.code = x.Code;
                s.stopGroupId = x.StopGroupId;
                s.stopGroupName = x.StopGroupName;
                s.isDisable = x.IsDisabled;
                return s;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage, result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0, 0);
        } finally {
            this.isLoading = false;
        }
    }

    async addNew() {
        let popup = new StopReasonEditorViewModel(this, new StopReasonInserter());
        let result = await this.showPopup(popup);
        if (result == 'done') {
            this.dataLoader.refresh();
        }
    }

    async edit(stopReason: IStopReason) {
        let popup = new StopReasonEditorViewModel(this, new StopReasonUpdater());
        await stopReason.cloneTo(popup);
        let result = await this.requestShowingPopup(popup);
        if (result == 'done') {
            this.dataLoader.refresh();
        }
    }

    async enable(stopReason: IStopReason) {
        let result = await ServerConnection.callServer("/Complex/StopReasonServices/EnableStopReason", {
            StopReasonId: stopReason.id
        });
        if (result.IsSuccessful == true) {
            this.dataLoader.refresh();
        }
    }

    async disable(stopReason: IStopReason) {
        let result = await ServerConnection.callServer("/Complex/StopReasonServices/DisableStopReason", {
            StopReasonId: stopReason.id
        });
        if (result.IsSuccessful == true) {
            this.dataLoader.refresh();
        }
    }
}

export class StopReason extends ViewModel implements IStopReason {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: StopReasonManipulationViewModel) {
        super(parent);
        this._typedParent = parent;
    }

    private _typedParent: StopReasonManipulationViewModel;
    public set index(v: number) { this._index = v; } public get index(): number { return this._index; } private _index: number;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code; } private _code: string;
    public set stopGroupId(v: string) { this._stopGroupId = v; } public get stopGroupId(): string { return this._stopGroupId; } private _stopGroupId: string;
    public set stopGroupName(v: string) { this._stopGroupName = v; } public get stopGroupName(): string { return this._stopGroupName; } private _stopGroupName: string;
    public set stopGroupSelector(v: StopGroupSelectorViewModel) { this._stopGroupSelector = v; } public get stopGroupSelector(): StopGroupSelectorViewModel { return this._stopGroupSelector; } private _stopGroupSelector: StopGroupSelectorViewModel;
    public set isDisable(v: boolean) { this._isDisable = v; } public get isDisable(): boolean { return this._isDisable; } private _isDisable: boolean;

    setStopGroupId(id: string) {
        this.stopGroupId = id;
    }
    getStopGroupId(): string {
        return this.stopGroupId;
    }

    async cloneTo(stopReason: IStopReason) {
        stopReason.id = this.id;
        stopReason.name = this.name;
        stopReason.setStopGroupId(this.getStopGroupId());
    }

    async edit() {
        this._typedParent.edit(this);
    }

    async enable() {
        let isDeleted = await this.messageBoxWarningYesNo(`آیا کد علت توقف ${this.code} غیرفعال سازی شود؟`, `غیرفعال سازی`);
        if (isDeleted == 'yes') {
            this._typedParent.enable(this);
        }
    }

    async disable() {
        let isDeleted = await this.messageBoxWarningYesNo(`آیا کد علت توقف ${this.code} فعال سازی شود؟`, `فعال سازی`);
        if (isDeleted == 'yes') {
            this._typedParent.disable(this);
        }
    }
}
